import { observable } from "mobx";

export class Supplier {
    @observable id: string;

    constructor() {
        this.id = "";
    }
}